/** 车型/子车型多值字段的读写辅助：后端已是数组，兼容滚动发布期的历史字符串值。 */

import { useLanguageStore } from '@/store/languageStore';
import type { Lang } from '@/store/languageStore';

const currentLang = (): Lang => useLanguageStore.getState().lang;

export function toVehicleList(value?: string | string[] | null): string[] {
  if (Array.isArray(value)) return value.filter(Boolean);
  return value ? [value] : [];
}

export function formatVehicleList(
  value?: string | string[] | null,
  lang: Lang = currentLang()
): string {
  const list = toVehicleList(value);
  return list.length ? list.join(lang === 'en' ? ', ' : '、') : '-';
}
